import { render, staticRenderFns } from "./AddShipment.vue?vue&type=template&id=4dd1a7be&scoped=true"
import script from "./AddShipment.vue?vue&type=script&lang=js"
export * from "./AddShipment.vue?vue&type=script&lang=js"
import style0 from "./AddShipment.vue?vue&type=style&index=0&id=4dd1a7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd1a7be",
  null
  
)

export default component.exports